/**
 * Whether nothing can be sent to this farm's devices: the server listens beside FMS-Control and
 * the farm hasn't been cut over on its own (account.inControl). The shell works it out once
 * for the farm on screen; screens read it here.
 */
import { createContext, useContext } from "react";
import { api } from "./api.ts";
import { useLoad } from "./ui.tsx";

export const ListenContext = createContext<boolean | undefined>(undefined);

export function useListenOnly(): boolean {
  const known: boolean | undefined = useContext(ListenContext);
  // Outside the shell (shouldn't happen): ask the server.
  const h = useLoad(() => (known === undefined ? api.health() : Promise.resolve(null)), [known === undefined]);
  return known ?? h.data?.listenOnly === true;
}
